import { useDataGridState as o } from "./index.es762.js";
function d(t) {
  return o().getRowByIndex(t);
}
export {
  d as useRow
};
//# sourceMappingURL=index.es761.js.map
